import React, { Fragment } from 'react'
import Drawer from '../../../../../constants/Drawer'
import { defaultEmployeeData, MemberInfoProps } from '../../../../../helpers/models/Models';
import MemberCardView from './card_and_bill/MemberCardView';
import BillListView from './card_and_bill/BillListView';
import { EndBaseLine } from '../../../../../constants/AppSpace';
import { Button } from '../../../../../constants/Button';
import { CiWarning } from 'react-icons/ci';
interface SalesDetailsDrawerProps {
  open: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  totalProductAmt: number | string;
  vatPerc: number;
  disAmt: number;
  disPerc: number;
  finalTotalAmt: number;
  employeeData: MemberInfoProps;
  values: any;
  handleSubmit: any;
}

const SalesDetailsDrawer: React.FC<SalesDetailsDrawerProps> = (props) => {
  return (
    <Drawer position="right" width="w-[380px]" showCloseIcon={true} closeIcon={false} className="relative z-50" header open={props.open} close={() => props.onClose(false)}>
      <div className="w-full h-full">
        {
          props.employeeData.results ? <Fragment>
            <MemberCardView employeeData={props.employeeData || defaultEmployeeData} />
            <BillListView values={props.values} />
            <div className='pr-2'>
              <EndBaseLine top={20}>
                <Button onClick={()=>{props.handleSubmit()}} btn_type='add' type='button' el='button' />
              </EndBaseLine>
            </div>
          </Fragment> :
            <Fragment>
              <div id="alert-additional-content-1" className="p-4 mb-4 text-red-800 border border-red-300 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 dark:border-red-800" role="alert">
                <div className="flex items-center">
                  <CiWarning size={22} />
                  <span className="sr-only">Info</span>
                  <h3 className="text-lg font-medium ml-2">Member doesn't exists!</h3>
                </div>
                <div className="mt-2 mb-4 text-[12px]">
                  Member does not exist in our records. Please verify the member details and try again, or contact support if you believe this is an error.              </div>
                <div className="flex">
                  <button type="button" onClick={() => props.onClose(false)} className="text-white bg-red-800 hover:bg-red-900 focus:ring-4 focus:outline-none focus:ring-red-200 font-medium rounded-lg text-xs px-3 py-1.5 me-2 text-center inline-flex items-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
                    <svg className="me-2 h-3 w-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 14">
                      <path d="M10 0C4.612 0 0 5.336 0 7c0 1.742 3.546 7 10 7 6.454 0 10-5.258 10-7 0-1.664-4.612-7-10-7Zm0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" />
                    </svg>
                    Dismiss
                  </button>

                </div>
              </div>
            </Fragment>
        }


      </div>
    </Drawer>

  )
}

export default SalesDetailsDrawer